export const mockUrl = [
]

export const baseMockUrl = 'http://120.79.172.144:3000/mock/20'
